/*! For license information please see app.js.LICENSE.txt */
(() => {
    var e = {
            669: (e, t, n) => {
                e.exports = n(609)
            },
            448: (e, t, n) => {
                "use strict";
                var i = n(867),
                    r = n(26),
                    s = n(372),
                    o = n(327),
                    a = n(97),
                    u = n(109),
                    c = n(985),
                    l = n(61);
                e.exports = function(e) {
                    return new Promise((function(t, n) {
                        var d = e.data,
                            p = e.headers;
                        i.isFormData(d) && delete p["Content-Type"];
                        var f = new XMLHttpRequest;
                        if (e.auth) {
                            var h = e.auth.username || "",
                                m = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
                            p.Authorization = "Basic " + btoa(h + ":" + m)
                        }
                        var v = a(e.baseURL, e.url);
                        if (f.open(e.method.toUpperCase(), o(v, e.params, e.paramsSerializer), !0), f.timeout = e.timeout, f.onreadystatechange = function() {
                                if (f && 4 === f.readyState && (0 !== f.status || f.responseURL && 0 === f.responseURL.indexOf("file:"))) {
                                    var i = "getAllResponseHeaders" in f ? u(f.getAllResponseHeaders()) : null,
                                        s = {
                                            data: e.responseType && "text" !== e.responseType ? f.response : f.responseText,
                                            status: f.status,
                                            statusText: f.statusText,
                                            headers: i,
                                            config: e,
                                            request: f
                                        };
                                    r(t, n, s), f = null
                                }
                            }, f.onabort = function() {
                                f && (n(l("Request aborted", e, "ECONNABORTED", f)), f = null)
                            }, f.onerror = function() {
                                n(l("Network Error", e, null, f)), f = null
                            }, f.ontimeout = function() {
                                var t = "timeout of " + e.timeout + "ms exceeded";
                                e.timeoutErrorMessage && (t = e.timeoutErrorMessage), n(l(t, e, "ECONNABORTED", f)), f = null
                            }, i.isStandardBrowserEnv()) {
                            var g = (e.withCredentials || c(v)) && e.xsrfCookieName ? s.read(e.xsrfCookieName) : void 0;
                            g && (p[e.xsrfHeaderName] = g)
                        }
                        if ("setRequestHeader" in f && i.forEach(p, (function(e, t) {
                                void 0 === d && "content-type" === t.toLowerCase() ? delete p[t] : f.setRequestHeader(t, e)
                            })), i.isUndefined(e.withCredentials) || (f.withCredentials = !!e.withCredentials), e.responseType) try {
                            f.responseType = e.responseType
                        } catch (t) {
                            if ("json" !== e.responseType) throw t
                        }
                        "function" == typeof e.onDownloadProgress && f.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && f.upload && f.upload.addEventListener("progress", e.onUploadProgress), e.cancelToken && e.cancelToken.promise.then((function(e) {
                            f && (f.abort(), n(e), f = null)
                        })), d || (d = null), f.send(d)
                    }))
                }
            },
            609: (e, t, n) => {
                "use strict";
                var i = n(867),
                    r = n(849),
                    s = n(321),
                    o = n(185);

                function a(e) {
                    var t = new s(e),
                        n = r(s.prototype.request, t);
                    return i.extend(n, s.prototype, t), i.extend(n, t), n
                }
                var u = a(n(655));
                u.Axios = s, u.create = function(e) {
                    return a(o(u.defaults, e))
                }, u.Cancel = n(263), u.CancelToken = n(972), u.isCancel = n(502), u.all = function(e) {
                    return Promise.all(e)
                }, u.spread = n(713), u.isAxiosError = n(268), e.exports = u, e.exports.default = u
            },
            263: e => {
                "use strict";

                function t(e) {
                    this.message = e
                }
                t.prototype.toString = function() {
                    return "Cancel" + (this.message ? ": " + this.message : "")
                }, t.prototype.__CANCEL__ = !0, e.exports = t
            },
            972: (e, t, n) => {
                "use strict";
                var i = n(263);

                function r(e) {
                    if ("function" != typeof e) throw new TypeError("executor must be a function.");
                    var t;
                    this.promise = new Promise((function(e) {
                        t = e
                    }));
                    var n = this;
                    e((function(e) {
                        n.reason || (n.reason = new i(e), t(n.reason))
                    }))
                }
                r.prototype.throwIfRequested = function() {
                    if (this.reason) throw this.reason
                }, r.source = function() {
                    var e;
                    return {
                        token: new r((function(t) {
                            e = t
                        })),
                        cancel: e
                    }
                }, e.exports = r
            },
            502: e => {
                "use strict";
                e.exports = function(e) {
                    return !(!e || !e.__CANCEL__)
                }
            },
            321: (e, t, n) => {
                "use strict";
                var i = n(867),
                    r = n(327),
                    s = n(782),
                    o = n(572),
                    a = n(185);

                function u(e) {
                    this.defaults = e, this.interceptors = {
                        request: new s,
                        response: new s
                    }
                }
                u.prototype.request = function(e) {
                    "string" == typeof e ? (e = arguments[1] || {}).url = arguments[0] : e = e || {}, (e = a(this.defaults, e)).method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
                    var t = [o, void 0],
                        n = Promise.resolve(e);
                    for (this.interceptors.request.forEach((function(e) {
                            t.unshift(e.fulfilled, e.rejected)
                        })), this.interceptors.response.forEach((function(e) {
                            t.push(e.fulfilled, e.rejected)
                        })); t.length;) n = n.then(t.shift(), t.shift());
                    return n
                }, u.prototype.getUri = function(e) {
                    return e = a(this.defaults, e), r(e.url, e.params, e.paramsSerializer).replace(/^\?/, "")
                }, i.forEach(["delete", "get", "head", "options"], (function(e) {
                    u.prototype[e] = function(t, n) {
                        return this.request(a(n || {}, {
                            method: e,
                            url: t,
                            data: (n || {}).data
                        }))
                    }
                })), i.forEach(["post", "put", "patch"], (function(e) {
                    u.prototype[e] = function(t, n, i) {
                        return this.request(a(i || {}, {
                            method: e,
                            url: t,
                            data: n
                        }))
                    }
                })), e.exports = u
            },
            782: (e, t, n) => {
                "use strict";
                var i = n(867);

                function r() {
                    this.handlers = []
                }
                r.prototype.use = function(e, t) {
                    return this.handlers.push({
                        fulfilled: e,
                        rejected: t
                    }), this.handlers.length - 1
                }, r.prototype.eject = function(e) {
                    this.handlers[e] && (this.handlers[e] = null)
                }, r.prototype.forEach = function(e) {
                    i.forEach(this.handlers, (function(t) {
                        null !== t && e(t)
                    }))
                }, e.exports = r
            },
            97: (e, t, n) => {
                "use strict";
                var i = n(793),
                    r = n(303);
                e.exports = function(e, t) {
                    return e && !i(t) ? r(e, t) : t
                }
            },
            61: (e, t, n) => {
                "use strict";
                var i = n(481);
                e.exports = function(e, t, n, r, s) {
                    var o = new Error(e);
                    return i(o, t, n, r, s)
                }
            },
            572: (e, t, n) => {
                "use strict";
                var i = n(867),
                    r = n(527),
                    s = n(502),
                    o = n(655);

                function a(e) {
                    e.cancelToken && e.cancelToken.throwIfRequested()
                }
                e.exports = function(e) {
                    return a(e), e.headers = e.headers || {}, e.data = r(e.data, e.headers, e.transformRequest), e.headers = i.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), i.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (function(t) {
                        delete e.headers[t]
                    })), (e.adapter || o.adapter)(e).then((function(t) {
                        return a(e), t.data = r(t.data, t.headers, e.transformResponse), t
                    }), (function(t) {
                        return s(t) || (a(e), t && t.response && (t.response.data = r(t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t)
                    }))
                }
            },
            481: e => {
                "use strict";
                e.exports = function(e, t, n, i, r) {
                    return e.config = t, n && (e.code = n), e.request = i, e.response = r, e.isAxiosError = !0, e.toJSON = function() {
                        return {
                            message: this.message,
                            name: this.name,
                            description: this.description,
                            number: this.number,
                            fileName: this.fileName,
                            lineNumber: this.lineNumber,
                            columnNumber: this.columnNumber,
                            stack: this.stack,
                            config: this.config,
                            code: this.code
                        }
                    }, e
                }
            },
            185: (e, t, n) => {
                "use strict";
                var i = n(867);
                e.exports = function(e, t) {
                    t = t || {};
                    var n = {},
                        r = ["url", "method", "data"],
                        s = ["headers", "auth", "proxy", "params"],
                        o = ["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "timeoutMessage", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "decompress", "maxContentLength", "maxBodyLength", "maxRedirects", "transport", "httpAgent", "httpsAgent", "cancelToken", "socketPath", "responseEncoding"],
                        a = ["validateStatus"];

                    function u(e, t) {
                        return i.isPlainObject(e) && i.isPlainObject(t) ? i.merge(e, t) : i.isPlainObject(t) ? i.merge({}, t) : i.isArray(t) ? t.slice() : t
                    }

                    function c(r) {
                        i.isUndefined(t[r]) ? i.isUndefined(e[r]) || (n[r] = u(void 0, e[r])) : n[r] = u(e[r], t[r])
                    }
                    i.forEach(r, (function(e) {
                        i.isUndefined(t[e]) || (n[e] = u(void 0, t[e]))
                    })), i.forEach(s, c), i.forEach(o, (function(r) {
                        i.isUndefined(t[r]) ? i.isUndefined(e[r]) || (n[r] = u(void 0, e[r])) : n[r] = u(void 0, t[r])
                    })), i.forEach(a, (function(i) {
                        i in t ? n[i] = u(e[i], t[i]) : i in e && (n[i] = u(void 0, e[i]))
                    }));
                    var l = r.concat(s).concat(o).concat(a),
                        d = Object.keys(e).concat(Object.keys(t)).filter((function(e) {
                            return -1 === l.indexOf(e)
                        }));
                    return i.forEach(d, c), n
                }
            },
            26: (e, t, n) => {
                "use strict";
                var i = n(61);
                e.exports = function(e, t, n) {
                    var r = n.config.validateStatus;
                    n.status && r && !r(n.status) ? t(i("Request failed with status code " + n.status, n.config, null, n.request, n)) : e(n)
                }
            },
            527: (e, t, n) => {
                "use strict";
                var i = n(867);
                e.exports = function(e, t, n) {
                    return i.forEach(n, (function(n) {
                        e = n(e, t)
                    })), e
                }
            },
            655: (e, t, n) => {
                "use strict";
                var i = n(867),
                    r = n(16),
                    s = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };

                function o(e, t) {
                    !i.isUndefined(e) && i.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t)
                }
                var a, u = {
                    adapter: (("undefined" != typeof XMLHttpRequest || "undefined" != typeof process && "[object process]" === Object.prototype.toString.call(process)) && (a = n(448)), a),
                    transformRequest: [function(e, t) {
                        return r(t, "Accept"), r(t, "Content-Type"), i.isFormData(e) || i.isArrayBuffer(e) || i.isBuffer(e) || i.isStream(e) || i.isFile(e) || i.isBlob(e) ? e : i.isArrayBufferView(e) ? e.buffer : i.isURLSearchParams(e) ? (o(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : i.isObject(e) ? (o(t, "application/json;charset=utf-8"), JSON.stringify(e)) : e
                    }],
                    transformResponse: [function(e) {
                        if ("string" == typeof e) try {
                            e = JSON.parse(e)
                        } catch (e) {}
                        return e
                    }],
                    timeout: 0,
                    xsrfCookieName: "XSRF-TOKEN",
                    xsrfHeaderName: "X-XSRF-TOKEN",
                    maxContentLength: -1,
                    maxBodyLength: -1,
                    validateStatus: function(e) {
                        return e >= 200 && e < 300
                    },
                    headers: {
                        common: {
                            Accept: "application/json, text/plain, */*"
                        }
                    }
                };
                i.forEach(["delete", "get", "head"], (function(e) {
                    u.headers[e] = {}
                })), i.forEach(["post", "put", "patch"], (function(e) {
                    u.headers[e] = i.merge(s)
                })), e.exports = u
            },
            849: e => {
                "use strict";
                e.exports = function(e, t) {
                    return function() {
                        for (var n = new Array(arguments.length), i = 0; i < n.length; i++) n[i] = arguments[i];
                        return e.apply(t, n)
                    }
                }
            },
            327: (e, t, n) => {
                "use strict";
                var i = n(867);

                function r(e) {
                    return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]")
                }
                e.exports = function(e, t, n) {
                    if (!t) return e;
                    var s;
                    if (n) s = n(t);
                    else if (i.isURLSearchParams(t)) s = t.toString();
                    else {
                        var o = [];
                        i.forEach(t, (function(e, t) {
                            null != e && (i.isArray(e) ? t += "[]" : e = [e], i.forEach(e, (function(e) {
                                i.isDate(e) ? e = e.toISOString() : i.isObject(e) && (e = JSON.stringify(e)), o.push(r(t) + "=" + r(e))
                            })))
                        })), s = o.join("&")
                    }
                    if (s) {
                        var a = e.indexOf("#"); - 1 !== a && (e = e.slice(0, a)), e += (-1 === e.indexOf("?") ? "?" : "&") + s
                    }
                    return e
                }
            },
            303: e => {
                "use strict";
                e.exports = function(e, t) {
                    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e
                }
            },
            372: (e, t, n) => {
                "use strict";
                var i = n(867);
                e.exports = i.isStandardBrowserEnv() ? {
                    write: function(e, t, n, r, s, o) {
                        var a = [];
                        a.push(e + "=" + encodeURIComponent(t)), i.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), i.isString(r) && a.push("path=" + r), i.isString(s) && a.push("domain=" + s), !0 === o && a.push("secure"), document.cookie = a.join("; ")
                    },
                    read: function(e) {
                        var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
                        return t ? decodeURIComponent(t[3]) : null
                    },
                    remove: function(e) {
                        this.write(e, "", Date.now() - 864e5)
                    }
                } : {
                    write: function() {},
                    read: function() {
                        return null
                    },
                    remove: function() {}
                }
            },
            793: e => {
                "use strict";
                e.exports = function(e) {
                    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)
                }
            },
            268: e => {
                "use strict";
                e.exports = function(e) {
                    return "object" == typeof e && !0 === e.isAxiosError
                }
            },
            985: (e, t, n) => {
                "use strict";
                var i = n(867);
                e.exports = i.isStandardBrowserEnv() ? function() {
                    var e, t = /(msie|trident)/i.test(navigator.userAgent),
                        n = document.createElement("a");

                    function r(e) {
                        var i = e;
                        return t && (n.setAttribute("href", i), i = n.href), n.setAttribute("href", i), {
                            href: n.href,
                            protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
                            host: n.host,
                            search: n.search ? n.search.replace(/^\?/, "") : "",
                            hash: n.hash ? n.hash.replace(/^#/, "") : "",
                            hostname: n.hostname,
                            port: n.port,
                            pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname
                        }
                    }
                    return e = r(window.location.href),
                        function(t) {
                            var n = i.isString(t) ? r(t) : t;
                            return n.protocol === e.protocol && n.host === e.host
                        }
                }() : function() {
                    return !0
                }
            },
            16: (e, t, n) => {
                "use strict";
                var i = n(867);
                e.exports = function(e, t) {
                    i.forEach(e, (function(n, i) {
                        i !== t && i.toUpperCase() === t.toUpperCase() && (e[t] = n, delete e[i])
                    }))
                }
            },
            109: (e, t, n) => {
                "use strict";
                var i = n(867),
                    r = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
                e.exports = function(e) {
                    var t, n, s, o = {};
                    return e ? (i.forEach(e.split("\n"), (function(e) {
                        if (s = e.indexOf(":"), t = i.trim(e.substr(0, s)).toLowerCase(), n = i.trim(e.substr(s + 1)), t) {
                            if (o[t] && r.indexOf(t) >= 0) return;
                            o[t] = "set-cookie" === t ? (o[t] ? o[t] : []).concat([n]) : o[t] ? o[t] + ", " + n : n
                        }
                    })), o) : o
                }
            },
            713: e => {
                "use strict";
                e.exports = function(e) {
                    return function(t) {
                        return e.apply(null, t)
                    }
                }
            },
            867: (e, t, n) => {
                "use strict";
                var i = n(849),
                    r = Object.prototype.toString;

                function s(e) {
                    return "[object Array]" === r.call(e)
                }

                function o(e) {
                    return void 0 === e
                }

                function a(e) {
                    return null !== e && "object" == typeof e
                }

                function u(e) {
                    if ("[object Object]" !== r.call(e)) return !1;
                    var t = Object.getPrototypeOf(e);
                    return null === t || t === Object.prototype
                }

                function c(e) {
                    return "[object Function]" === r.call(e)
                }

                function l(e, t) {
                    if (null != e)
                        if ("object" != typeof e && (e = [e]), s(e))
                            for (var n = 0, i = e.length; n < i; n++) t.call(null, e[n], n, e);
                        else
                            for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.call(null, e[r], r, e)
                }
                e.exports = {
                    isArray: s,
                    isArrayBuffer: function(e) {
                        return "[object ArrayBuffer]" === r.call(e)
                    },
                    isBuffer: function(e) {
                        return null !== e && !o(e) && null !== e.constructor && !o(e.constructor) && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e)
                    },
                    isFormData: function(e) {
                        return "undefined" != typeof FormData && e instanceof FormData
                    },
                    isArrayBufferView: function(e) {
                        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && e.buffer instanceof ArrayBuffer
                    },
                    isString: function(e) {
                        return "string" == typeof e
                    },
                    isNumber: function(e) {
                        return "number" == typeof e
                    },
                    isObject: a,
                    isPlainObject: u,
                    isUndefined: o,
                    isDate: function(e) {
                        return "[object Date]" === r.call(e)
                    },
                    isFile: function(e) {
                        return "[object File]" === r.call(e)
                    },
                    isBlob: function(e) {
                        return "[object Blob]" === r.call(e)
                    },
                    isFunction: c,
                    isStream: function(e) {
                        return a(e) && c(e.pipe)
                    },
                    isURLSearchParams: function(e) {
                        return "undefined" != typeof URLSearchParams && e instanceof URLSearchParams
                    },
                    isStandardBrowserEnv: function() {
                        return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document
                    },
                    forEach: l,
                    merge: function e() {
                        var t = {};

                        function n(n, i) {
                            u(t[i]) && u(n) ? t[i] = e(t[i], n) : u(n) ? t[i] = e({}, n) : s(n) ? t[i] = n.slice() : t[i] = n
                        }
                        for (var i = 0, r = arguments.length; i < r; i++) l(arguments[i], n);
                        return t
                    },
                    extend: function(e, t, n) {
                        return l(t, (function(t, r) {
                            e[r] = n && "function" == typeof t ? i(t, n) : t
                        })), e
                    },
                    trim: function(e) {
                        return e.replace(/^\s*/, "").replace(/\s*$/, "")
                    },
                    stripBOM: function(e) {
                        return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e
                    }
                }
            },
            358: (e, t, n) => {
                "use strict";
                n.r(t)
            },
            314: (e, t) => {
                "use strict";
                t.Z = function(e) {
                    var t, n = new Set,
                        i = function(e, i) {
                            var r = "function" == typeof e ? e(t) : e;
                            if (r !== t) {
                                var s = t;
                                t = i ? r : Object.assign({}, t, r), n.forEach((function(e) {
                                    return e(t, s)
                                }))
                            }
                        },
                        r = function() {
                            return t
                        },
                        s = {
                            setState: i,
                            getState: r,
                            subscribe: function(e, i, s) {
                                return i || s ? function(e, i, s) {
                                    void 0 === i && (i = r), void 0 === s && (s = Object.is);
                                    var o = i(t);

                                    function a() {
                                        var n = i(t);
                                        if (!s(o, n)) {
                                            var r = o;
                                            e(o = n, r)
                                        }
                                    }
                                    return n.add(a),
                                        function() {
                                            return n.delete(a)
                                        }
                                }(e, i, s) : (n.add(e), function() {
                                    return n.delete(e)
                                })
                            },
                            destroy: function() {
                                return n.clear()
                            }
                        };
                    return t = e(i, r, s), s
                }
            }
        },
        t = {};

    function n(i) {
        var r = t[i];
        if (void 0 !== r) return r.exports;
        var s = t[i] = {
            exports: {}
        };
        return e[i](s, s.exports, n), s.exports
    }
    n.n = e => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return n.d(t, {
            a: t
        }), t
    }, n.d = (e, t) => {
        for (var i in t) n.o(t, i) && !n.o(e, i) && Object.defineProperty(e, i, {
            enumerable: !0,
            get: t[i]
        })
    }, n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n.r = e => {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }, (() => {
        "use strict";

        function e(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e
        }

        function t(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
            return i
        }

        function i(e) {
            return function(e) {
                if (Array.isArray(e)) return t(e)
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e)
            }(e) || function(e, n) {
                if (e) {
                    if ("string" == typeof e) return t(e, n);
                    var i = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? t(e, n) : void 0
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }

        function r(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }

        function s(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
            }
        }

        function o(e, t, n) {
            return t && s(e.prototype, t), n && s(e, n), e
        }

        function a(e, t) {
            return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
                raw: {
                    value: Object.freeze(t)
                }
            }))
        }
        const u = new WeakMap,
            c = e => "function" == typeof e && u.has(e),
            l = "undefined" != typeof window && null != window.customElements && void 0 !== window.customElements.polyfillWrapFlushCallback,
            d = (e, t, n = null) => {
                for (; t !== n;) {
                    const n = t.nextSibling;
                    e.removeChild(t), t = n
                }
            },
            p = {},
            f = {},
            h = `}`,
            m = `\x3c!--${h}--\x3e`,
            v = new RegExp(`${h}|${m}`),
            g = "$lit$";
        class y {
            constructor(e, t) {
                this.parts = [], this.element = t;
                const n = [],
                    i = [],
                    r = document.createTreeWalker(t.content, 133, null, !1);
                let s = 0,
                    o = -1,
                    a = 0;
                const {
                    strings: u,
                    values: {
                        length: c
                    }
                } = e;
                for (; a < c;) {
                    const e = r.nextNode();
                    if (null !== e) {
                        if (o++, 1 === e.nodeType) {
                            if (e.hasAttributes()) {
                                const t = e.attributes,
                                    {
                                        length: n
                                    } = t;
                                let i = 0;
                                for (let e = 0; e < n; e++) b(t[e].name, g) && i++;
                                for (; i-- > 0;) {
                                    const t = u[a],
                                        n = w.exec(t)[2],
                                        i = n.toLowerCase() + g,
                                        r = e.getAttribute(i);
                                    e.removeAttribute(i);
                                    const s = r.split(v);
                                    this.parts.push({
                                        type: "attribute",
                                        index: o,
                                        name: n,
                                        strings: s
                                    }), a += s.length - 1
                                }
                            }
                            "TEMPLATE" === e.tagName && (i.push(e), r.currentNode = e.content)
                        } else if (3 === e.nodeType) {
                            const t = e.data;
                            if (t.indexOf(h) >= 0) {
                                const i = e.parentNode,
                                    r = t.split(v),
                                    s = r.length - 1;
                                for (let t = 0; t < s; t++) {
                                    let n, s = r[t];
                                    if ("" === s) n = k();
                                    else {
                                        const e = w.exec(s);
                                        null !== e && b(e[2], g) && (s = s.slice(0, e.index) + e[1] + e[2].slice(0, -g.length) + e[3]), n = document.createTextNode(s)
                                    }
                                    i.insertBefore(n, e), this.parts.push({
                                        type: "node",
                                        index: ++o
                                    })
                                }
                                "" === r[s] ? (i.insertBefore(k(), e), n.push(e)) : e.data = r[s], a += s
                            }
                        } else if (8 === e.nodeType)
                            if (e.data === h) {
                                const t = e.parentNode;
                                null !== e.previousSibling && o !== s || (o++, t.insertBefore(k(), e)), s = o, this.parts.push({
                                    type: "node",
                                    index: o
                                }), null === e.nextSibling ? e.data = "" : (n.push(e), o--), a++
                            } else {
                                let t = -1;
                                for (; - 1 !== (t = e.data.indexOf(h, t + 1));) this.parts.push({
                                    type: "node",
                                    index: -1
                                }), a++
                            }
                    } else r.currentNode = i.pop()
                }
                for (const e of n) e.parentNode.removeChild(e)
            }
        }
        const b = (e, t) => {
                const n = e.length - t.length;
                return n >= 0 && e.slice(n) === t
            },
            _ = e => -1 !== e.index,
            k = () => document.createComment(""),
            w = /([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;
        class C {
            constructor(e, t, n) {
                this.__parts = [], this.template = e, this.processor = t, this.options = n
            }
            update(e) {
                let t = 0;
                for (const n of this.__parts) void 0 !== n && n.setValue(e[t]), t++;
                for (const e of this.__parts) void 0 !== e && e.commit()
            }
            _clone() {
                const e = l ? this.template.element.content.cloneNode(!0) : document.importNode(this.template.element.content, !0),
                    t = [],
                    n = this.template.parts,
                    i = document.createTreeWalker(e, 133, null, !1);
                let r, s = 0,
                    o = 0,
                    a = i.nextNode();
                for (; s < n.length;)
                    if (r = n[s], _(r)) {
                        for (; o < r.index;) o++, "TEMPLATE" === a.nodeName && (t.push(a), i.currentNode = a.content), null === (a = i.nextNode()) && (i.currentNode = t.pop(), a = i.nextNode());
                        if ("node" === r.type) {
                            const e = this.processor.handleTextExpression(this.options);
                            e.insertAfterNode(a.previousSibling), this.__parts.push(e)
                        } else this.__parts.push(...this.processor.handleAttributeExpressions(a, r.name, r.strings, this.options));
                        s++
                    } else this.__parts.push(void 0), s++;
                return l && (document.adoptNode(e), customElements.upgrade(e)), e
            }
        }
        const S = window.trustedTypes && trustedTypes.createPolicy("lit-html", {
                createHTML: e => e
            }),
            N = ` ${h} `;
        class x {
            constructor(e, t, n, i) {
                this.strings = e, this.values = t, this.type = n, this.processor = i
            }
            getHTML() {
                const e = this.strings.length - 1;
                let t = "",
                    n = !1;
                for (let i = 0; i < e; i++) {
                    const e = this.strings[i],
                        r = e.lastIndexOf("\x3c!--");
                    n = (r > -1 || n) && -1 === e.indexOf("--\x3e", r + 1);
                    const s = w.exec(e);
                    t += null === s ? e + (n ? N : m) : e.substr(0, s.index) + s[1] + s[2] + g + s[3] + h
                }
                return t += this.strings[e], t
            }
            getTemplateElement() {
                const e = document.createElement("template");
                let t = this.getHTML();
                return void 0 !== S && (t = S.createHTML(t)), e.innerHTML = t, e
            }
        }
        const A = e => null === e || !("object" == typeof e || "function" == typeof e),
            E = e => Array.isArray(e) || !(!e || !e[Symbol.iterator]);
        class O {
            constructor(e, t, n) {
                this.dirty = !0, this.element = e, this.name = t, this.strings = n, this.parts = [];
                for (let e = 0; e < n.length - 1; e++) this.parts[e] = this._createPart()
            }
            _createPart() {
                return new T(this)
            }
            _getValue() {
                const e = this.strings,
                    t = e.length - 1,
                    n = this.parts;
                if (1 === t && "" === e[0] && "" === e[1]) {
                    const e = n[0].value;
                    if ("symbol" == typeof e) return String(e);
                    if ("string" == typeof e || !E(e)) return e
                }
                let i = "";
                for (let r = 0; r < t; r++) {
                    i += e[r];
                    const t = n[r];
                    if (void 0 !== t) {
                        const e = t.value;
                        if (A(e) || !E(e)) i += "string" == typeof e ? e : String(e);
                        else
                            for (const t of e) i += "string" == typeof t ? t : String(t)
                    }
                }
                return i += e[t], i
            }
            commit() {
                this.dirty && (this.dirty = !1, this.element.setAttribute(this.name, this._getValue()))
            }
        }
        class T {
            constructor(e) {
                this.value = void 0, this.committer = e
            }
            setValue(e) {
                e === p || A(e) && e === this.value || (this.value = e, c(e) || (this.committer.dirty = !0))
            }
            commit() {
                for (; c(this.value);) {
                    const e = this.value;
                    this.value = p, e(this)
                }
                this.value !== p && this.committer.commit()
            }
        }
        class j {
            constructor(e) {
                this.value = void 0, this.__pendingValue = void 0, this.options = e
            }
            appendInto(e) {
                this.startNode = e.appendChild(k()), this.endNode = e.appendChild(k())
            }
            insertAfterNode(e) {
                this.startNode = e, this.endNode = e.nextSibling
            }
            appendIntoPart(e) {
                e.__insert(this.startNode = k()), e.__insert(this.endNode = k())
            }
            insertAfterPart(e) {
                e.__insert(this.startNode = k()), this.endNode = e.endNode, e.endNode = this.startNode
            }
            setValue(e) {
                this.__pendingValue = e
            }
            commit() {
                if (null === this.startNode.parentNode) return;
                for (; c(this.__pendingValue);) {
                    const e = this.__pendingValue;
                    this.__pendingValue = p, e(this)
                }
                const e = this.__pendingValue;
                e !== p && (A(e) ? e !== this.value && this.__commitText(e) : e instanceof x ? this.__commitTemplateResult(e) : e instanceof Node ? this.__commitNode(e) : E(e) ? this.__commitIterable(e) : e === f ? (this.value = f, this.clear()) : this.__commitText(e))
            }
            __insert(e) {
                this.endNode.parentNode.insertBefore(e, this.endNode)
            }
            __commitNode(e) {
                this.value !== e && (this.clear(), this.__insert(e), this.value = e)
            }
            __commitText(e) {
                const t = this.startNode.nextSibling,
                    n = "string" == typeof(e = null == e ? "" : e) ? e : String(e);
                t === this.endNode.previousSibling && 3 === t.nodeType ? t.data = n : this.__commitNode(document.createTextNode(n)), this.value = e
            }
            __commitTemplateResult(e) {
                const t = this.options.templateFactory(e);
                if (this.value instanceof C && this.value.template === t) this.value.update(e.values);
                else {
                    const n = new C(t, e.processor, this.options),
                        i = n._clone();
                    n.update(e.values), this.__commitNode(i), this.value = n
                }
            }
            __commitIterable(e) {
                Array.isArray(this.value) || (this.value = [], this.clear());
                const t = this.value;
                let n, i = 0;
                for (const r of e) n = t[i], void 0 === n && (n = new j(this.options), t.push(n), 0 === i ? n.appendIntoPart(this) : n.insertAfterPart(t[i - 1])), n.setValue(r), n.commit(), i++;
                i < t.length && (t.length = i, this.clear(n && n.endNode))
            }
            clear(e = this.startNode) {
                d(this.startNode.parentNode, e.nextSibling, this.endNode)
            }
        }
        class P {
            constructor(e, t, n) {
                if (this.value = void 0, this.__pendingValue = void 0, 2 !== n.length || "" !== n[0] || "" !== n[1]) throw new Error("Boolean attributes can only contain a single expression");
                this.element = e, this.name = t, this.strings = n
            }
            setValue(e) {
                this.__pendingValue = e
            }
            commit() {
                for (; c(this.__pendingValue);) {
                    const e = this.__pendingValue;
                    this.__pendingValue = p, e(this)
                }
                if (this.__pendingValue === p) return;
                const e = !!this.__pendingValue;
                this.value !== e && (e ? this.element.setAttribute(this.name, "") : this.element.removeAttribute(this.name), this.value = e), this.__pendingValue = p
            }
        }
        class q extends O {
            constructor(e, t, n) {
                super(e, t, n), this.single = 2 === n.length && "" === n[0] && "" === n[1]
            }
            _createPart() {
                return new D(this)
            }
            _getValue() {
                return this.single ? this.parts[0].value : super._getValue()
            }
            commit() {
                this.dirty && (this.dirty = !1, this.element[this.name] = this._getValue())
            }
        }
        class D extends T {}
        let L = !1;
        (() => {
            try {
                const e = {
                    get capture() {
                        return L = !0, !1
                    }
                };
                window.addEventListener("test", e, e), window.removeEventListener("test", e, e)
            } catch (e) {}
        })();
        class B {
            constructor(e, t, n) {
                this.value = void 0, this.__pendingValue = void 0, this.element = e, this.eventName = t, this.eventContext = n, this.__boundHandleEvent = e => this.handleEvent(e)
            }
            setValue(e) {
                this.__pendingValue = e
            }
            commit() {
                for (; c(this.__pendingValue);) {
                    const e = this.__pendingValue;
                    this.__pendingValue = p, e(this)
                }
                if (this.__pendingValue === p) return;
                const e = this.__pendingValue,
                    t = this.value,
                    n = null == e || null != t && (e.capture !== t.capture || e.once !== t.once || e.passive !== t.passive),
                    i = null != e && (null == t || n);
                n && this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options), i && (this.__options = M(e), this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options)), this.value = e, this.__pendingValue = p
            }
            handleEvent(e) {
                "function" == typeof this.value ? this.value.call(this.eventContext || this.element, e) : this.value.handleEvent(e)
            }
        }
        const M = e => e && (L ? {
                capture: e.capture,
                passive: e.passive,
                once: e.once
            } : e.capture),
            R = new class {
                handleAttributeExpressions(e, t, n, i) {
                    const r = t[0];
                    return "." === r ? new q(e, t.slice(1), n).parts : "@" === r ? [new B(e, t.slice(1), i.eventContext)] : "?" === r ? [new P(e, t.slice(1), n)] : new O(e, t, n).parts
                }
                handleTextExpression(e) {
                    return new j(e)
                }
            };

        function I(e) {
            let t = V.get(e.type);
            void 0 === t && (t = {
                stringsArray: new WeakMap,
                keyString: new Map
            }, V.set(e.type, t));
            let n = t.stringsArray.get(e.strings);
            if (void 0 !== n) return n;
            const i = e.strings.join(h);
            return n = t.keyString.get(i), void 0 === n && (n = new y(e, e.getTemplateElement()), t.keyString.set(i, n)), t.stringsArray.set(e.strings, n), n
        }
        const V = new Map,
            U = new WeakMap,
            W = (e, t, n) => {
                let i = U.get(t);
                void 0 === i && (d(t, t.firstChild), U.set(t, i = new j(Object.assign({
                    templateFactory: I
                }, n))), i.appendInto(t)), i.setValue(e), i.commit()
            };
        "undefined" != typeof window && (window.litHtmlVersions || (window.litHtmlVersions = [])).push("1.3.0");
        const F = (e, ...t) => new x(e, t, "html", R);
        class H {
            constructor(e) {
                this.classes = new Set, this.changed = !1, this.element = e;
                const t = (e.getAttribute("class") || "").split(/\s+/);
                for (const e of t) this.classes.add(e)
            }
            add(e) {
                this.classes.add(e), this.changed = !0
            }
            remove(e) {
                this.classes.delete(e), this.changed = !0
            }
            commit() {
                if (this.changed) {
                    let e = "";
                    this.classes.forEach((t => e += t + " ")), this.element.setAttribute("class", e)
                }
            }
        }
        const Q = new WeakMap,
            Z = (z = e => t => {
                if (!(t instanceof T) || t instanceof D || "class" !== t.committer.name || t.committer.parts.length > 1) throw new Error("The `classMap` directive must be used in the `class` attribute and must be the only part in the attribute.");
                const {
                    committer: n
                } = t, {
                    element: i
                } = n;
                let r = Q.get(t);
                void 0 === r && (i.setAttribute("class", n.strings.join(" ")), Q.set(t, r = new Set));
                const s = i.classList || new H(i);
                r.forEach((t => {
                    t in e || (s.remove(t), r.delete(t))
                }));
                for (const t in e) {
                    const n = e[t];
                    n != r.has(t) && (n ? (s.add(t), r.add(t)) : (s.remove(t), r.delete(t)))
                }
                "function" == typeof s.commit && s.commit()
            }, (...e) => {
                const t = z(...e);
                return u.set(t, !0), t
            });
        var z, G = n(314),
            K = n(669),
            $ = n.n(K);

        function Y() {
            var e = a([' <div class="skinid23__desc">\n            <span>\n              <svg\n                width="20"\n                height="20"\n                viewBox="0 0 20 20"\n                fill="none"\n                xmlns="http://www.w3.org/2000/svg"\n              >\n                <circle cx="10" cy="10" r="10" fill="#F6DDD0" />\n                <path\n                  d="M11 6.04C10.6667 6.04 10.4067 5.94667 10.22 5.76C10.0333 5.57333 9.94 5.31333 9.94 4.98C9.94 4.68667 10.0333 4.45333 10.22 4.28C10.42 4.09333 10.68 4 11 4C11.32 4 11.5667 4.09333 11.74 4.28C11.9133 4.45333 12 4.68667 12 4.98C12 5.31333 11.9133 5.57333 11.74 5.76C11.5667 5.94667 11.32 6.04 11 6.04ZM9.68 16.3C9.09333 16.3 8.8 15.9533 8.8 15.26C8.8 15.0067 8.84 14.7 8.92 14.34L9.74 10.18C9.78 9.99333 9.8 9.83333 9.8 9.7C9.8 9.32667 9.67333 9.14 9.42 9.14C9.1 9.14 8.69333 9.42 8.2 9.98C8.18667 9.99333 8.16667 10 8.14 10C8.08667 10 8.04667 9.98 8.02 9.94C7.99333 9.88667 7.99333 9.84 8.02 9.8C8.5 9.25333 8.92667 8.85333 9.3 8.6C9.68667 8.34667 10.06 8.22 10.42 8.22C11.0067 8.22 11.3 8.54667 11.3 9.2C11.3 9.4 11.2667 9.66667 11.2 10L10.38 14.34C10.34 14.54 10.32 14.7067 10.32 14.84C10.32 15.1867 10.4333 15.36 10.66 15.36C10.8867 15.36 11.2733 15.1067 11.82 14.6C11.8467 14.5733 11.8733 14.56 11.9 14.56C11.94 14.56 11.9733 14.5867 12 14.64C12.0267 14.68 12.02 14.72 11.98 14.76C11.5267 15.2933 11.12 15.6867 10.76 15.94C10.4 16.18 10.04 16.3 9.68 16.3Z"\n                  fill="#76777A"\n                />\n              </svg>\n            </span>\n            ', "\n          </div>"]);
            return Y = function() {
                return e
            }, e
        }

        function X() {
            var e = a([' <li class="skinid23__continue">\n              <button\n                ?disabled=', '\n                class="skinid23-continue-button"\n                @click=', "\n              >\n                CONTINUE\n              </button>\n            </li>"]);
            return X = function() {
                return e
            }, e
        }

        function J() {
            var e = a(['<img src="', '" />']);
            return J = function() {
                return e
            }, e
        }

        function ee() {
            var e = a(['\n            <li\n              data-icon="', '"\n              class="skinid23__answer ', '"\n            >\n              <span @click=', ">\n                ", "\n                ", "\n              </span>\n            </li>\n          "]);
            return ee = function() {
                return e
            }, e
        }

        function te(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);
                t && (i = i.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }))), n.push.apply(n, i)
            }
            return n
        }

        function ne(t) {
            for (var n = 1; n < arguments.length; n++) {
                var i = null != arguments[n] ? arguments[n] : {};
                n % 2 ? te(Object(i), !0).forEach((function(n) {
                    e(t, n, i[n])
                })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : te(Object(i)).forEach((function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e))
                }))
            }
            return t
        }

        function ie() {
            var e = a(['\n              <li\n                class="skinid23-nav__list ', '"\n                @click=', '\n                style="width: ', 'px"\n              >\n                <span class="skinid23-nav__index">\n                  <span style="', '" class="_circle"></span>\n                  ', '\n                </span>\n                <span class="skinid23-nav__title">\n                  ', "\n                </span>\n              </li>\n            "]);
            return ie = function() {
                return e
            }, e
        }

        function re() {
            var e = a(['\n    <div class="skinid23-nav-container">\n      <button\n        class="skinid23-nav-btn skinid23-nav-btn--prev"\n        @click="', '"\n      >\n        <svg\n          width="18"\n          height="18"\n          viewBox="0 0 18 18"\n          fill="none"\n          xmlns="http://www.w3.org/2000/svg"\n        >\n          <path\n            d="M11.25 16.875L4.5 9L11.25 1.125"\n            stroke="#76777A"\n            stroke-linecap="round"\n            stroke-linejoin="round"\n          />\n        </svg>\n      </button>\n      <div class="skinid23-nav-wrap">\n        <ul class="skinid23-nav" style="width: ', 'px">\n          ', '\n        </ul>\n      </div>\n      <button\n        class="skinid23-nav-btn skinid23-nav-btn--next"\n        @click="', '"\n      >\n        <svg\n          width="18"\n          height="18"\n          viewBox="0 0 18 18"\n          fill="none"\n          xmlns="http://www.w3.org/2000/svg"\n        >\n          <path\n            d="M4.5 16.875L11.25 9L4.5 1.125"\n            stroke="#76777A"\n            stroke-linecap="round"\n            stroke-linejoin="round"\n          />\n        </svg>\n      </button>\n    </div>\n    <div class="skinid23">\n      <div class="skinid23__lead">', '</div>\n      <div class="skinid23__question">', '</div>\n      <ul class="skinid23__answers ', '">\n        ', "\n        ", "\n      </ul>\n      ", "\n    </div>\n  "]);
            return re = function() {
                return e
            }, e
        }

        function se() {
            var e = a(['<p class="skinid23__form-error">', "</p>"]);
            return se = function() {
                return e
            }, e
        }

        function oe() {
            var e = a(['\n    <div class="skinid23">\n      <header class="skinid23__header">\n        <div class="skinid23__lead">YOUR SKIN IDENTITY CHECK</div>\n        <div class="skinid23__title">\n          You are one step away from your custom formula!\n        </div>\n      </header>\n      <form class="skinid23__form" id="formEmail" @submit=', ">\n        <input\n          ?disabled=", '\n          name="email"\n          placeholder="ENTER YOUR EMAIL ADDRESS"\n          class="skinid23-input"\n        />\n        ', "\n        <button ?disabled=", ' class="skinid23__submit">\n          SUBMIT\n        </button>\n      </form>\n    </div>\n  ']);
            return oe = function() {
                return e
            }, e
        }

        function ae() {
            var e = a(['<p class="skinid23__form-error">', "</p>"]);
            return ae = function() {
                return e
            }, e
        }

        function ue() {
            var e = a(['\n    <div class="skinid23-wrap">\n      <img class="skinid23-bg" src="', '" />\n      <div class="skinid23">\n        <header class="skinid23__header">\n          <div class="skinid23__lead">YOUR SKIN IDENTITY CHECK</div>\n          <div class="skinid23__title">Customize Your Skincare in Minutes</div>\n\n          <p class="skinid23__subtitle">\n            Did you know up to 80% of skin concerns are caused by lifestyle and\n            environment? One size does not fit all. You are unique, and so is\n            your skin. Our quick diagnostic tool and proprietary algorithm\n            relies upon a database of over 1 million skin profiles. Take the\n            quiz and let us build a custom serum cocktail, personalized for your\n            skin.\n          </p>\n        </header>\n\n        <div class="skinid23__time">TIME: 2 - 3 MINUTES</div>\n        <div class="skinid23__question">Name your formula</div>\n        <form class="skinid23__form" id="formName" @submit=', '>\n          <input\n            name="firstName"\n            placeholder="FIRST NAME"\n            class="skinid23-input"\n          />\n          <input\n            name="lastName"\n            placeholder="LAST NAME"\n            class="skinid23-input"\n          />\n          ', '\n          <button class="skinid23__submit">SUBMIT</button>\n        </form>\n      </div>\n    </div>\n  ']);
            return ue = function() {
                return e
            }, e
        }

        function ce(e) {
            return F(ue(), window.skinid23.landingBg, e.onSubmit, e.data.error ? F(ae(), e.data.error) : "")
        }

        function le(e) {
            return e.reduce((function(e, t) {
                return e.push({
                    lead: t.tag,
                    title: t.Name,
                    type: t.type.toLocaleLowerCase(),
                    answers: t.answers,
                    desc: t.description,
                    tagColor: t.tagColor,
                    trackKey: t.customerTagKey.replace("js-", "")
                }), e
            }), [])
        }
        var de = function() {
            function e() {
                var t = this,
                    n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                r(this, e);
                var i = n.mount,
                    s = n.customer,
                    o = void 0 === s ? {} : s;
                this.ops = n, this.endCallback = n.endCallback, this.scene = i, this.introStore = (0, G.Z)((function() {
                    return {
                        submitted: !1,
                        firstName: o.firstName,
                        lastName: o.lastName,
                        error: ""
                    }
                })), this.introStore.subscribe((function(e) {
                    t.renderIntro({
                        error: e.error
                    }), e.submitted && e.firstName && e.lastName && t.prepareRenderQuestion()
                })), this.questionStore = (0, G.Z)((function(e) {
                    return {
                        isLoading: !0,
                        nav: {
                            currentPage: 1,
                            itemWidth: 140,
                            totalWidth: 0
                        },
                        current: 0,
                        questions: {
                            female: [],
                            male: []
                        },
                        genderQuestion: "",
                        gender: "",
                        answers: [],
                        clickNav: !1
                    }
                })), this.questionStore.subscribe((function(e) {
                    if (t.prepareRenderQuestion(), e.gender && e.current > e.questions[e.gender].length) {
                        var n = e.questions[e.gender][e.current - 2],
                            i = t.getCurrentAnswer(e);
                        if ("multi" === n.type && i && 3 === i.length) return setTimeout((function() {
                            return t.renderEmail()
                        }), 200);
                        if (i) return setTimeout((function() {
                            return t.renderEmail()
                        }), 200)
                    }
                })), this.emailStore = (0, G.Z)((function(e) {
                    return {
                        email: o.email,
                        submitted: !1,
                        error: ""
                    }
                })), this.emailStore.subscribe((function(e) {
                    t.renderEmail()
                }))
            }
            return o(e, [{
                key: "calcNavState",
                value: function(e) {
                    var t = window.innerWidth >= 1280 ? 110 : 90;
                    return {
                        itemWidth: t,
                        totalWidth: (e + 1) * t
                    }
                }
            }, {
                key: "getCurrentQuestion",
                value: function(e) {
                    return e.questions[e.gender][e.current - 1]
                }
            }, {
                key: "getCurrentAnswer",
                value: function(e) {
                    return e.answers[e.current - 1]
                }
            }, {
                key: "handleSubmitEmailForm",
                value: function(e) {
                    e.preventDefault(), this.emailStore.setState({
                        submitted: !0
                    });
                    var t = document.querySelector("#formEmail input").value;
                    this.handleNextStep(t)
                }
            }, {
                key: "handleNextStep",
                value: function(e) {
                    var t = this;
                    if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e)) {
                        var n = this.introStore.getState(),
                            i = this.questionStore.getState(),
                            r = [{
                                key: i.genderQuestion.trackKey,
                                answers: ["female" === i.gender ? "Female" : "Male"]
                            }],
                            s = i.questions[i.gender].reduce((function(e, t, n) {
                                var s = i.answers[n + 1];
                                return e.push({
                                    question: t.title,
                                    answers: Array.isArray(s) ? s.reduce((function(e, t) {
                                        return e.push(t.title), e
                                    }), []) : [s.title]
                                }), r.push({
                                    key: t.trackKey,
                                    answers: Array.isArray(s) ? s.reduce((function(e, t) {
                                        return e.push(t.title), e
                                    }), []) : [s.title]
                                }), e
                            }), []),
                            o = {
                                firstName: n.firstName,
                                lastName: n.lastName,
                                email: e,
                                type: i.gender,
                                answers: s
                            };
                        this.ops.appControl.setAppLoading(), this.ops.onSendData(o, r, (function(e) {
                            t.ops.appControl.removeAppLoading(), t.emailStore.setState({
                                error: e,
                                submitted: !1
                            })
                        }))
                    } else this.emailStore.setState({
                        error: "Invalid email address",
                        submitted: !1
                    })
                }
            }, {
                key: "renderEmail",
                value: function() {
                    if (this.ops.customer) return W(this.ops.appControl.renderLoading(), this.scene), void this.handleNextStep(this.ops.customer.email);
                    var e, t = this.emailStore.getState();
                    W((e = {
                        data: ne({}, t),
                        onSubmit: this.handleSubmitEmailForm.bind(this)
                    }, F(oe(), e.onSubmit, e.data.submitted, e.data.error ? F(se(), e.data.error) : "", e.data.submitted)), this.scene)
                }
            }, {
                key: "renderIntro",
                value: function() {
                    var e = this,
                        t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    W(ce({
                        data: t,
                        onSubmit: function(t) {
                            t.preventDefault();
                            var n = new FormData(t.target),
                                i = n.get("firstName"),
                                r = n.get("lastName"),
                                s = i && r ? "" : "Please fill in the details above";
                            e.introStore.setState({
                                submitted: !s,
                                firstName: i,
                                lastName: r,
                                error: s
                            })
                        }
                    }), this.scene)
                }
            }, {
                key: "renderQuestion",
                value: function(e) {
                    W(function(e) {
                        var t = e.questions,
                            n = e.genderQuestion,
                            i = e.nav,
                            r = e.navData,
                            s = e.answers,
                            o = e.gender,
                            a = e.current,
                            u = 0 === a ? n : t[o][a - 1],
                            c = s[a],
                            l = "multi" === u.type,
                            d = {
                                "skinid23__answers--center": u.answers.length < 3,
                                "skinid23__answers--multi": l
                            },
                            p = {
                                "skinid23__answer--multi": l
                            };
                        return F(re(), e.onClickNavPrev, r.totalWidth, i.map((function(t, n) {
                            var i = 0 === n || s[n],
                                u = !o && 0 === n || a === n,
                                c = "";
                            return u ? c = "".concat(c, " background-color: ").concat(t.tagColor, "; border-color: ").concat(t.tagColor, ";") : i && (c = "".concat(c, "  border-color: ").concat(t.tagColor, ";")), F(ie(), i || u ? "" : "skinid23-nav__list--un", i ? e.onClickNav(n) : void 0, r.itemWidth, c, n + 1, o || 0 === n ? t.title : "")
                        })), e.onClickNavNext, u.lead, u.title, Z(d), u.answers.map((function(t, n) {
                            var i = ne({}, p);
                            if (Array.isArray(c)) {
                                var r = c.find((function(e) {
                                    return e.title === t.title
                                }));
                                i = ne(ne({}, i), {}, {
                                    "skinid23__answer--checked": !!r
                                })
                            } else i = ne(ne({}, i), {}, {
                                "skinid23__answer--checked": c && c.title === t.title
                            });
                            return F(ee(), t.icon, Z(i), e.onClickQuestion(t, n), t.icon ? F(J(), t.icon) : "", t.title)
                        })), l ? F(X(), !c || Array.isArray(c) && 0 === c.length, e.onClickContinueQuestion) : "", u.desc ? F(Y(), u.desc) : "")
                    }(e), this.scene)
                }
            }, {
                key: "selectAnswer",
                value: function(e, t) {
                    var n = this.questionStore.getState();
                    0 === n.current ? this.questionStore.setState({
                        gender: e.title.toLowerCase(),
                        current: 1,
                        answers: [e],
                        clickNav: !1
                    }) : "multi" === n.questions[n.gender][n.current - 1].type ? this.selectAnswerMulti(n, e, t) : this.selectAnswerSingle(n, e, t)
                }
            }, {
                key: "selectAnswerContinue",
                value: function() {
                    var e = this.questionStore.getState();
                    if ("multi" === e.questions[e.gender][e.current - 1].type) {
                        var t = e.current + 1 <= e.questions[e.gender].length ? e.current + 1 : e.current;
                        this.questionStore.setState({
                            current: t,
                            clickNav: !1
                        })
                    }
                }
            }, {
                key: "selectAnswerMulti",
                value: function(e, t, n) {
                    var r = i(e.answers),
                        s = r[e.current] || [];
                    s.find((function(e) {
                        return e.title === t.title
                    })) ? s = s.filter((function(e) {
                        return e.title !== t.title
                    })) : 3 === s.length ? s[2] = t : s.push(t), r[e.current] = s;
                    var o = s && 3 === s.length ? e.current + 1 : e.current;
                    this.questionStore.setState({
                        current: o,
                        answers: r,
                        clickNav: !1
                    })
                }
            }, {
                key: "selectAnswerSingle",
                value: function(e, t, n) {
                    var r = e.answers[e.current],
                        s = i(e.answers);
                    r ? s[e.current] = t : s = [].concat(i(s), [t]), this.questionStore.setState({
                        current: e.current + 1,
                        answers: s,
                        clickNav: !1
                    })
                }
            }, {
                key: "prepareRenderQuestion",
                value: function() {
                    var e = this,
                        t = this.questionStore.getState(),
                        n = [{
                            title: t.genderQuestion.lead,
                            tagColor: t.genderQuestion.tagColor
                        }],
                        i = t.questions[t.gender || "female"];
                    i.forEach((function(e) {
                        n.push({
                            title: e.lead,
                            tagColor: e.tagColor
                        })
                    }));
                    var r = this.calcNavState(i.length + 1),
                        s = ne(ne({}, t), {}, {
                            navData: r,
                            onClickNavPrev: this.handleNavPrev.bind(this),
                            onClickNavNext: this.handleNavNext.bind(this),
                            onClickContinueQuestion: this.selectAnswerContinue.bind(this)
                        });
                    if (0 === t.current) this.renderQuestion(ne(ne({}, s), {}, {
                        onClickQuestion: function(t) {
                            return e.selectAnswer.bind(e, t, 0)
                        },
                        onClickNav: this.handleNav.bind(this),
                        nav: n
                    })), document.body.scrollTop = 0, document.documentElement.scrollTop = 0;
                    else {
                        var o = t.questions[t.gender][s.current - 1];
                        t.clickNav || o && "multi" === o.type || this.renderQuestion(ne(ne({}, s), {}, {
                            current: s.current - 1,
                            nav: n,
                            onClickNav: this.handleNav.bind(this),
                            onClickQuestion: function(t, n) {
                                return e.selectAnswer.bind(e, t, n)
                            }
                        })), t.current <= t.questions[t.gender].length && setTimeout((function() {
                            return e.renderQuestion(ne(ne({}, s), {}, {
                                current: s.current,
                                nav: n,
                                onClickNav: e.handleNav.bind(e),
                                onClickQuestion: function(t, n) {
                                    return e.selectAnswer.bind(e, t, n)
                                }
                            }))
                        }), 200)
                    }
                    var a = document.querySelector(".skinid23-nav-wrap"),
                        u = this.calcNavInfo({
                            itemWidth: r.itemWidth,
                            current: t.current,
                            questions: i.length + 1,
                            wrapWidth: a.clientWidth
                        }),
                        c = u.displayPerView,
                        l = u.totalPage;
                    u.currentPage, t.current >= c ? a.scrollLeft = (Math.ceil((t.current + 1) / c) - 1) * c * r.itemWidth : a.scrollLeft = 0;
                    var d = Math.ceil(t.current / c) || 1;
                    a.setAttribute("data-page", d.toString()), this.calcNavBtn(d, l)
                }
            }, {
                key: "calcNavInfo",
                value: function(e) {
                    var t = e.itemWidth,
                        n = e.current,
                        i = e.questions,
                        r = e.wrapWidth,
                        s = Math.floor(r / t);
                    return {
                        displayPerView: s,
                        totalPage: Math.ceil(i / s),
                        currentPage: n + 1 < s ? 1 : Math.floor((n + 1) / s)
                    }
                }
            }, {
                key: "calcNavBtn",
                value: function(e, t) {
                    var n = document.querySelector(".skinid23-nav-btn--prev"),
                        i = document.querySelector(".skinid23-nav-btn--next");
                    i.style.display = "initial", n.style.display = "initial", 1 === e ? n.style.display = "none" : e === t ? i.style.display = "none" : (i.style.display = "initial", n.style.display = "initial")
                }
            }, {
                key: "handleNav",
                value: function(e) {
                    var t = this;
                    return function() {
                        t.questionStore.setState({
                            current: e,
                            clickNav: !0
                        })
                    }
                }
            }, {
                key: "handleNavPrev",
                value: function() {
                    var e = this.questionStore.getState(),
                        t = e.questions[e.gender || "female"],
                        n = this.calcNavState(t.length + 1),
                        i = document.querySelector(".skinid23-nav-wrap"),
                        r = this.calcNavInfo({
                            itemWidth: n.itemWidth,
                            current: e.current,
                            questions: t.length + 1,
                            wrapWidth: i.clientWidth
                        }),
                        s = r.displayPerView,
                        o = r.totalPage,
                        a = r.currentPage,
                        u = parseInt(i.getAttribute("data-page"), 10) || a;
                    u > 1 && (i.scrollLeft = (u - 2) * s * n.itemWidth, i.setAttribute("data-page", u - 1), this.calcNavBtn(u - 1, o))
                }
            }, {
                key: "handleNavNext",
                value: function() {
                    var e = this.questionStore.getState(),
                        t = e.questions[e.gender || "female"],
                        n = this.calcNavState(t.length + 1),
                        i = document.querySelector(".skinid23-nav-wrap"),
                        r = this.calcNavInfo({
                            itemWidth: n.itemWidth,
                            current: e.current,
                            questions: t.length + 1,
                            wrapWidth: i.clientWidth
                        }),
                        s = r.displayPerView,
                        o = r.totalPage,
                        a = r.currentPage,
                        u = parseInt(i.getAttribute("data-page"), 10) || a;
                    u !== o && (i.scrollLeft = u * s * n.itemWidth, i.setAttribute("data-page", u + 1), this.calcNavBtn(u + 1, o))
                }
            }, {
                key: "start",
                value: function() {
                    var e = this;
                    this.ops.appControl.setGAEvent("SkinId Application", "Start"), this.ops.appControl.setAppLoading(), $().get(this.ops.config.api.getQuestion, {
                        headers: {
                            "x-api-key": this.ops.config.apiKey
                        }
                    }).then((function(t) {
                        e.questionStore.setState({
                            isLoading: !1,
                            genderQuestion: le([t.data.questions.gender])[0],
                            questions: {
                                male: le(t.data.questions.male),
                                female: le(t.data.questions.female)
                            },
                            clickNav: !1
                        }), e.ops.customer ? e.prepareRenderQuestion() : e.renderIntro()
                    })).finally((function() {
                        e.ops.appControl.removeAppLoading()
                    }))
                }
            }, {
                key: "end",
                value: function() {
                    this.introStore.destroy(), this.questionStore.destroy(), this.emailStore.destroy()
                }
            }]), e
        }();

        function pe(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);
                t && (i = i.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }))), n.push.apply(n, i)
            }
            return n
        }

        function fe(t) {
            for (var n = 1; n < arguments.length; n++) {
                var i = null != arguments[n] ? arguments[n] : {};
                n % 2 ? pe(Object(i), !0).forEach((function(n) {
                    e(t, n, i[n])
                })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : pe(Object(i)).forEach((function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e))
                }))
            }
            return t
        }

        function he() {
            var e = a(['\n                  <div class="skinid23-result-serum-final">\n                    <div class="skinid23-serum">\n                      <div\n                        class="skinid23-serum__img skinid23-serum__img--final"\n                      >\n                        <!--div class="skinid23-serum__equal">+</div-->\n                        <img\n                          src="', '"\n                        />\n                      </div>\n                      <h4 class="skinid23-serum__title">', '</h4>\n                      <p class="skinid23-serum__desc">', '</p>\n                      <p class="skinid23-serum__desc">', "</p>\n                      ", "\n                    </div>\n                  </div>\n                "]);
            return he = function() {
                return e
            }, e
        }

        function me() {
            var e = a([' <div class="skinid23-serum-plus">+</div>']);
            return me = function() {
                return e
            }, e
        }

        function ve() {
            var e = a(['\n                  <div class="skinid23-result-concern__item" role="listitem">\n                    <div class="skinid23-serum">\n                      <div class="skinid23-serum__img">\n                        <img\n                          src="', '"\n                        />\n                      </div>\n                      <h4 class="skinid23-serum__title">', '</h4>\n                      <p class="skinid23-serum__desc">', '</p>\n                      <p class="skinid23-serum__desc">', "</p>\n                    </div>\n                  </div>\n                  ", "\n                "]);
            return ve = function() {
                return e
            }, e
        }

        function ge() {
            var e = a(['\n                    <li\n                      @click="', '"\n                      class="skinid23-select-colors__round skinid23-select-colors__round--', " ", '"\n                    >\n                      <span />\n                    </li>\n                  ']);
            return ge = function() {
                return e
            }, e
        }

        function ye() {
            var e = a(['\n                  <div class="skinid23-result-serum-final">\n                    <div class="skinid23-serum">\n                      <div\n                        class="skinid23-serum__img skinid23-serum__img--final"\n                      >\n                        <div class="skinid23-serum__equal">=</div>\n                        <img\n                          src="', '"\n                        />\n                      </div>\n                      <h4 class="skinid23-serum__title">', '</h4>\n                      <p class="skinid23-serum__desc">', "</p>\n                      ", "\n                    </div>\n                  </div>\n                "]);
            return ye = function() {
                return e
            }, e
        }

        function be() {
            var e = a([' <div class="skinid23-serum-plus">+</div>']);
            return be = function() {
                return e
            }, e
        }

        function _e() {
            var e = a(['\n                  <div class="skinid23-result-concern__item" role="listitem">\n                    <div class="skinid23-serum">\n                      <div class="skinid23-serum__img">\n                        <img\n                          src="', '"\n                        />\n                      </div>\n                      <h4 class="skinid23-serum__title">', '</h4>\n                      <p class="skinid23-serum__desc">', "</p>\n                    </div>\n                  </div>\n                  ", "\n                "]);
            return _e = function() {
                return e
            }, e
        }

        function ke() {
            var e = a(['\n              <div class="skinid23-result-concern__item" role="listitem">\n                ', "\n              </div>\n            "]);
            return ke = function() {
                return e
            }, e
        }

        function we() {
            var e = a(['\n    <div class="skinid23" style="max-width: 1600px">\n      <h1 class="skinid23-result-title">Dear ', ',</h1>\n      <p class="skinid23-result-thank">\n        Thank you for sharing your skin profile with us. One size does not fit\n        all - you know your skin, and we know the science and data. Hereâ€™s a\n        snapshot of your unique skin identity, and a custom daily & nightly skin\n        cocktail personalized just for you!\n      </p>\n\n      <section>\n        <h2 class="skinid23-result-section-title">\n          You told us about some of your skin concerns:\n        </h2>\n        <div class="skinid23-result-concern" role="list">\n          ', '\n        </div>\n      </section>\n      <section>\n        <h2 class="skinid23-result-section-title">Your results:</h2>\n        <div class="skinid23-result-results">\n          <div class="skinid23-result-serum">\n            <div class="skinid23-result-serum__icon">\n              <svg\n                width="51"\n                height="25"\n                viewBox="0 0 51 25"\n                fill="none"\n                xmlns="http://www.w3.org/2000/svg"\n              >\n                <path\n                  d="M23.0057 24.2764C22.8261 24.2641 22.6588 24.2333 22.4978 24.1779C22.3367 24.1225 22.2624 24.0732 22.2748 24.0425L27.5154 0.374937C27.5278 0.294896 27.6269 0.264111 27.7941 0.276425C27.9614 0.288739 28.1286 0.325681 28.2897 0.387251C28.4507 0.448821 28.5251 0.516548 28.5003 0.590432L23.2783 24.2025C23.2721 24.2641 23.1792 24.2826 23.0057 24.2764Z"\n                  fill="#F6DDD0"\n                />\n                <path\n                  fill-rule="evenodd"\n                  clip-rule="evenodd"\n                  d="M50.7268 15.2931C48.9861 18.0945 45.8083 19.9786 42.2278 19.9786C36.6961 19.9786 32.2422 15.5024 32.2422 10.0535C32.2422 6.03294 34.5961 2.57271 38.0279 0.990356C37.0554 2.51729 36.4917 4.35208 36.4917 6.28538C36.4917 11.7836 40.9951 16.2105 46.5269 16.2105C48.0135 16.2105 49.4445 15.9026 50.7268 15.2931Z"\n                  fill="#F6DDD0"\n                />\n                <path\n                  fill-rule="evenodd"\n                  clip-rule="evenodd"\n                  d="M6.38004 4.29094C6.11987 4.19243 5.14732 3.83533 4.73848 3.6814C4.28008 3.53363 3.76593 3.42896 3.61107 3.42896C3.40665 3.47822 3.40665 4.24169 3.51196 4.70346C3.56151 5.15908 3.71638 5.76862 3.71638 6.02722C3.87124 6.8892 6.63402 4.39561 6.38004 4.29094ZM11.8065 3.53363C11.7074 3.27504 11.1932 2.41306 10.9392 2.0067C10.7348 1.64959 10.4251 1.19397 10.2702 1.13856C10.1154 1.04005 9.6074 1.64959 9.34723 2.0067C9.14281 2.41306 8.83309 2.97334 8.68442 3.17653C8.27557 3.93999 11.9613 3.78607 11.8065 3.53363ZM12.0605 5.41152C11.4472 5.25759 10.8339 5.15292 10.1649 5.15292C9.5021 5.15292 8.83309 5.25144 8.21982 5.41152C5.61191 6.2304 3.71638 8.66857 3.71638 11.5747C3.71638 15.1396 6.58446 17.9903 10.1711 17.9903C13.7082 17.9903 16.6258 15.1396 16.6258 11.5747C16.6258 8.66857 14.7241 6.2304 12.0605 5.41152ZM16.5205 6.43358C16.5701 6.12573 16.725 5.15908 16.8303 4.70346C16.8798 4.24784 16.9356 3.73681 16.8798 3.58289C16.8303 3.42896 16.0064 3.53363 15.5975 3.68756C15.1391 3.84148 14.5754 4.09392 14.3215 4.14318C13.4976 4.44487 16.471 6.68602 16.5205 6.43358ZM18.2117 11.6239C18.4161 11.47 19.1842 10.8112 19.5435 10.5034C19.9028 10.2509 20.2621 9.84456 20.3116 9.69064C20.4169 9.53671 19.6983 9.13035 19.2833 8.97642C18.8249 8.8225 18.2612 8.61932 18.001 8.52081C17.1834 8.21295 18.001 11.8271 18.2117 11.6239ZM16.1613 16.7158C16.4152 16.7158 17.4373 16.7158 17.9019 16.7158C18.3665 16.7158 18.8745 16.6604 19.0293 16.5619C19.1842 16.5126 18.924 15.7491 18.67 15.3428C18.4656 14.9364 18.1559 14.4254 18.001 14.1729C17.5922 13.4587 15.8515 16.7158 16.1613 16.7158ZM11.2923 19.314C11.4967 19.468 12.2649 20.1268 12.6242 20.4346C12.9834 20.7425 13.3923 20.9949 13.5967 21.0503C13.7516 21.0996 14.0551 20.3361 14.1109 19.8805C14.2162 19.4249 14.3153 18.8153 14.371 18.5567C14.5197 17.6824 11.0879 19.1047 11.2923 19.314ZM5.86589 18.1935C5.91545 18.4459 6.11987 19.4125 6.17562 19.8743C6.28093 20.3299 6.42959 20.841 6.5349 20.9456C6.64021 21.0996 7.35258 20.7425 7.71187 20.4346C8.07115 20.1268 8.53575 19.7204 8.74017 19.5726C9.40298 19.0062 5.86589 17.8856 5.86589 18.1935ZM2.48366 13.8651C2.32879 14.0683 1.8704 14.9364 1.61642 15.3428C1.36244 15.7491 1.20758 16.2047 1.15802 16.4079C1.15802 16.5619 1.9757 16.7158 2.4403 16.7158C2.90489 16.7158 3.51815 16.7158 3.77213 16.7158C4.79423 16.7158 2.58897 13.7112 2.48366 13.8651ZM2.68808 8.36688C2.4341 8.46539 1.46156 8.8225 1.05271 8.97642C0.588122 9.13035 0.129725 9.33353 0.0244172 9.48745C-0.130447 9.64138 0.383702 10.2509 0.742987 10.5034C1.10227 10.8112 1.56686 11.2176 1.77128 11.3715C2.48366 11.9318 2.94825 8.26221 2.68808 8.36688Z"\n                  fill="#F6DDD0"\n                />\n              </svg>\n            </div>\n            <h3 class="skinid23-result-serum__title">Your Daily Dose®</h3>\n            <div class="skinid23-serums">\n              ', "\n            </div>\n            ", '\n\n            <div class="skinid23-serum-colors">\n              <p>BOTTLE COLOUR:</p>\n              <ul class="skinid23-select-colors">\n                ', '\n              </ul>\n            </div>\n\n            <div class="skinid23-serum-add">\n              <button\n                ?disabled=', '\n                @click="', '"\n                class="skinid23__submit"\n              >\n                ADD TO BAG\n              </button>\n            </div>\n          </div>\n          <div class="skinid23-result-serum">\n            <div class="skinid23-result-serum__icon">\n              <svg\n                height="25"\n                viewBox="0 0 34 35"\n                fill="none"\n                xmlns="http://www.w3.org/2000/svg"\n              >\n                <path\n                  fill-rule="evenodd"\n                  clip-rule="evenodd"\n                  d="M34 26.3635C30.7993 31.5272 24.9561 35 18.3725 35C8.18961 35 0 26.738 0 16.7056C0 9.2834 4.32831 2.90532 10.6385 0C8.85025 2.81453 7.81374 6.1965 7.81374 9.76005C7.81374 19.8946 16.0945 28.0545 26.266 28.0545C29.0111 28.0545 31.6422 27.4984 34 26.3635Z"\n                  fill="#F6DDD0"\n                />\n              </svg>\n            </div>\n            <h3 class="skinid23-result-serum__title">Your Nightly Dose™</h3>\n            <div class="skinid23-serums">\n              ', "\n            </div>\n            ", '\n            <div class="skinid23-serum-add">\n              <button\n                ?disabled=', '\n                @click="', '"\n                class="skinid23__submit"\n              >\n                ADD TO BAG\n              </button>\n            </div>\n          </div>\n        </div>\n      </section>\n    </div>\n  ']);
            return we = function() {
                return e
            }, e
        }

        function Ce() {
            var e = a(['\n      <p class="skinid23-serum__desc">', '</p>\n      <p class="skinid23-serum__desc">\n        <span>', "</span>\n        <span>&nbsp;</span>\n        <s>", "</s>\n      </p>\n    "]);
            return Ce = function() {
                return e
            }, e
        }

        function Se() {
            var e = a(['\n      <p class="skinid23-serum__desc">', '</p>\n      <p class="skinid23-serum__desc">\n        <span>', "</span>\n        <span>&nbsp;</span>\n        <s>", "</s>\n      </p>\n    "]);
            return Se = function() {
                return e
            }, e
        }

        function Ne() {
            var e = a(['\n    <div class="skinid23-concern">\n      <div class="skinid23-concern__head">\n        <div class="skinid23-concern__img">\n          <img src="', '" alt="', '" />\n        </div>\n        <dl class="skinid23-concern__term">\n          <dt>Diagnosis:</dt>\n          <dd>', "</dd>\n          <dt>Serum Benefit:</dt>\n          <dd>", '</dd>\n        </dl>\n      </div>\n      <p class="skinid23-concern__desc">', "</p>\n    </div>\n  "]);
            return Ne = function() {
                return e
            }, e
        }

        function xe(e, t, n) {
            var i = e.resultEachGroup.find((function(e) {
                return e.type === t
            }));
            return i ? n ? i.result.splice(0, n) : i.result : []
        }
        var Ae = function() {
                function e() {
                    var t = this,
                        n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    r(this, e), this.ops = n, this.scene = this.ops.mount, this.resultStore = (0, G.Z)((function() {
                        return {
                            firstName: "",
                            lastName: "",
                            email: "",
                            isLoading: !0,
                            isAddingToBag: !1,
                            result: {},
                            products: {},
                            selectedBottle: 0
                        }
                    })), this.resultStore.subscribe((function() {
                        t.renderResult()
                    }))
                }
                return o(e, [{
                    key: "getVariant",
                    value: function() {
                        switch (this.ops.store) {
                            default:
                            case "sg":
                                return "variantSG";
                            case "row":
                                return "variantROW";
                            case "us":
                                return "variantUSA";
                            case "STAGING":
                                return "variantSTAGING"
                        }
                    }
                }, {
                    key: "getData",
                    value: function() {
                        var e = this;
                        this.ops.appControl.setAppLoading();
                        var t = this.ops.result,
                            n = {
                                serums: xe(t, "Serum", 3),
                                bottles: xe(t, "Bottle"),
                                marks: xe(t, "Moisturizer Kit", 1),
                                boosters: xe(t, "", 2)
                            },
                            i = [];
                        Object.keys(n).forEach((function(t) {
                                n[t].forEach((function(t) {
                                    var n = t[e.getVariant()].nodeId;
                                    n && i.push(n)
                                }))
                            })),
                            function(e, t) {
                                return new Promise((function(n, i) {
                                    $()({
                                        headers: {
                                            "X-Shopify-Storefront-Access-Token": t.storeAccessToken,
                                            "Content-Type": "application/graphql"
                                        },
                                        method: "post",
                                        url: t.api.storeGraphql,
                                        data: "\n{\n  nodes(ids: ".concat(JSON.stringify(e), ") {\n    ... on ProductVariant {\n      id\n      title\n      image {\n          originalSrc\n      }\n      product {\n          title\n      }\n      priceV2 {\n        amount\n        currencyCode\n      }\n      compareAtPriceV2 {\n        amount\n        currencyCode\n      }\n    }\n  }\n}\n")
                                    }).then((function(e) {
                                        n(e.data.data.nodes)
                                    })).catch((function(e) {
                                        i(e)
                                    }))
                                }))
                            }(i, this.ops.config).then((function(i) {
                                e.resultStore.setState(fe(fe({}, e.ops.user), {}, {
                                    isLoading: !1,
                                    result: n,
                                    price: t.price,
                                    /*products: i.reduce((function(e, t) {
                                        return e[t.id] = t, e
                                    }), {})*/

                                  products: i
                                    .filter(t => t !== null && t !== undefined)
                                    .reduce((function(e, t) {
                                        return e[t.id] = t, e;
                                    }), {})
                                }))
                            })).finally((function() {
                                e.ops.appControl.removeAppLoading(), n.serums.forEach((function(t) {
                                    e.ops.appControl.setGAEvent("Serum Results", t.analyticsTag || t.Name)
                                })), n.boosters.forEach((function(t) {
                                    e.ops.appControl.setGAEvent("CRSM Results", t.analyticsTag || t.Name)
                                })), n.marks.forEach((function(t) {
                                    e.ops.appControl.setGAEvent("CRSM Results", t.analyticsTag || t.Name)
                                }))
                            }))
                    }
                }, {
                    key: "handleAddToBag",
                    value: function(e) {
                        var t = this;
                        return function() {
                            var n = t.resultStore.getState(),
                                i = t.getVariant(),
                                r = [];
                            if ("daily" === e) {
                                t.ops.appControl.setAppLoading();
                                var s = n.result.bottles[n.selectedBottle];
                                r.push({
                                    quantity: 1,
                                    id: s[i].id
                                }), n.result.serums.forEach((function(e) {
                                    r.push({
                                        quantity: 1,
                                        id: e[i].id
                                    })
                                }))
                            } else if ("nightly" === e) {
                                t.ops.appControl.setAppLoading();
                                var o = n.result.marks[0];
                                r.push({
                                    quantity: 1,
                                    id: o[i].id
                                }), n.result.boosters.forEach((function(e) {
                                    r.push({
                                        quantity: 1,
                                        id: e[i].id
                                    })
                                }))
                            }
                            r.length > 0 && (t.resultStore.setState({
                                isAddingToBag: !0
                            }), $().post("/cart/add.js", {
                                items: r
                            }).then((function() {
                                t.ops.appControl.updateCart(r), t.ops.appControl.setGAEvent("SkinId Application", "Add To Cart")
                            })).finally((function() {
                                t.resultStore.setState({
                                    isAddingToBag: !1
                                }), t.ops.appControl.removeAppLoading()
                            })))
                        }
                    }
                }, {
                    key: "renderResult",
                    value: function() {
                        var e = this,
                            t = this.resultStore.getState();
                        W(function(e) {
                            var t = e.variant,
                                n = e.onChangeColor,
                                i = e.onAddToBag,
                                r = e.isAddingToBag,
                                s = e.data,
                                o = s.price;
                            if (s.isLoading) return "";
                            var a = s.result.bottles[s.selectedBottle],
                                u = null != o && o.dailyDose ? F(Se(), o.dailyDose.description, o.dailyDose.discountedPrice, o.dailyDose.originalPrice) : "",
                                c = s.products[a ? "gid://shopify/ProductVariant/"+a[t].id : ""],
                                l = s.result.marks[0],
                                d = s.products[l ? "gid://shopify/ProductVariant/"+l[t].id : ""],
                                p = null != o && o.nightlyDose ? F(Ce(), o.nightlyDose.description, o.nightlyDose.discountedPrice, o.nightlyDose.originalPrice) : "";
                            return c && Number.parseFloat(c.priceV2.amount), F(we(), s.firstName, s.result.serums.map((function(e) {
                                return F(ke(), function(e) {
                                    return F(Ne(), e.diagnosisImage, e.diagnosis, e.diagnosis, e.benefit, e.desc)
                                }({
                                    diagnosisImage: e.diagnosisImage,
                                    diagnosis: e.diagnosis,
                                    benefit: e.benefit,
                                    desc: e.diagnosisDetail
                                }))
                            })), s.result.serums.map((function(e, n) {
                              
                                    var i = "gid://shopify/ProductVariant/" + (e[t]?.id || "");
                                    var r = s.products[i];
                                
                                    if (!r) {
                                        console.warn(`Product not found for key ${i}. Skipping...`);
                                        return null; // Skip this item if product is undefined
                                    }
                                                            
                                    console.log(r);
                                    console.log(s);
                                    console.log(e);
                                    console.log(t);
                                return r.priceV2.amount && Number.parseFloat(r.priceV2.amount), F(_e(), r.image ? r.image.originalSrc : "", e.Name, e.benefit, 0 === n || 1 === n ? F(be()) : "")
                            })), c ? F(ye(), c.image ? c.image.originalSrc : "", a.Name, a.benefit, u) : "", s.result.bottles.map((function(e, t) {
                                return F(ge(), n(t), e.bottleColor, s.selectedBottle === t ? "skinid23-select-colors__round--selected" : "")
                            })), r, i("daily"), s.result.boosters.map((function(e, n) {
                                var i = "gid://shopify/ProductVariant/"+e[t].id,
                                    r = s.products[i];
                                return F(ve(), r.image ? r.image.originalSrc : "", e.Name, e.ingredient, e.benefit, 0 === n ? F(me()) : "")
                            })), d ? F(he(), d.image ? d.image.originalSrc : "", l.Name, l.ingredient, l.benefit, p) : "", r, i("nightly"))
                        }({
                            onChangeColor: function(t) {
                                return function() {
                                    e.resultStore.setState({
                                        selectedBottle: t
                                    })
                                }
                            },
                            onAddToBag: this.handleAddToBag.bind(this),
                            variant: this.getVariant(),
                            data: t
                        }), this.scene)
                    }
                }, {
                    key: "start",
                    value: function() {
                        this.getData()
                    }
                }]), e
            }(),
            Ee = {
                api: {
                    submitAnswers: "https://d3gk6ho87bjc47.cloudfront.net/api/quiz/v1.0/answers",
                    getQuestion: "https://d3gk6ho87bjc47.cloudfront.net/api/quiz/v1.0/questions",
                    storeGraphql: "https://skininc-dev.myshopify.com/api/2024-10/graphql.json"
                },
                store: "sg",
                storeAccessToken: "3f47fb3c955589d6aec911d32c728b5c",
                apiKey: "pwNP8fG0VeODh9ffy94Y6lHr5pcxttK8CwL6pPU9"
            };

        function Oe(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);
                t && (i = i.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }))), n.push.apply(n, i)
            }
            return n
        }

        function Te(t) {
            for (var n = 1; n < arguments.length; n++) {
                var i = null != arguments[n] ? arguments[n] : {};
                n % 2 ? Oe(Object(i), !0).forEach((function(n) {
                    e(t, n, i[n])
                })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : Oe(Object(i)).forEach((function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e))
                }))
            }
            return t
        }
        n(358), document.addEventListener("DOMContentLoaded", (function() {
            var e = new URLSearchParams(decodeURIComponent(window.location.search)).get("id"),
                t = document.getElementById("skinid"),
                n = {
                    setAppLoading: function() {
                        document.dispatchEvent(new CustomEvent("theme:loading:start"))
                    },
                    removeAppLoading: function() {
                        document.dispatchEvent(new CustomEvent("theme:loading:end"))
                    },
                    renderLoading: function() {
                        return ""
                    },
                    setGAEvent: function(e, t) {
                        void 0 !== window._analytics_id && void 0 !== window.gtag && window.gtag("event", e, {
                            event_category: "SkinId Wizard",
                            event_label: t,
                            value: 1
                        })
                    },
                    updateCart: function(e) {
                        e.forEach((function(e) {
                            getThis8.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    variant: e.id,
                                    quantity: e.quantity
                                }
                            }))
                        }))
                    }
                },
                i = new de({
                    config: Ee,
                    appControl: n,
                    mount: t,
                    onSendData: function(e, r, s) {
                        (function(e, t) {
                            return new Promise((function(n, i) {
                                $()({
                                    headers: {
                                        "x-api-key": t.apiKey
                                    },
                                    method: "post",
                                    url: t.api.submitAnswers,
                                    data: e
                                }).then((function(e) {
                                    n(e.data)
                                })).catch((function(e) {
                                    i(e)
                                }))
                            }))
                        })(Te(Te({}, e), {}, {
                            location: Ee.store.toUpperCase()
                        }), Ee).then((function(s) {
                            i.end();
                            var o = new Ae({
                                config: Ee,
                                appControl: n,
                                store: Ee.store,
                                result: s,
                                user: {
                                    firstName: e.firstName,
                                    lastName: e.lastName,
                                    email: e.email,
                                    type: e.type
                                },
                                mount: t
                            });
                            r.forEach((function(e) {
                                e.answers.forEach((function(t) {
                                    n.setGAEvent(e.key, t)
                                }))
                            })), o.start()
                        })).catch((function(e) {
                            s(e)
                        }))
                    },
                    customer: theme && theme.customerDetail ? theme.customerDetail : void 0
                });
            return e ? function(e, t) {
                return new Promise((function(n, i) {
                    $()({
                        headers: {
                            "x-api-key": t.apiKey
                        },
                        method: "get",
                        url: "".concat(t.api.submitAnswers, "/").concat(e)
                    }).then((function(e) {
                        n(e.data)
                    })).catch((function(e) {
                        i(e)
                    }))
                }))
            }(e, Ee).then((function(e) {
                new Ae({
                    config: Ee,
                    appControl: n,
                    store: Ee.store,
                    result: e,
                    user: {
                        firstName: e.firstName,
                        lastName: e.lastName,
                        email: e.email,
                        type: e.type
                    },
                    mount: t
                }).start()
            })).catch((function(e) {
                i.start()
            })) : i.start()
        }))
    })()
})();